export default __webpack_public_path__ + "static/media/livvy-image.de914df3.png";